import * as React from "react";

const MessagesLetterIconSVG = ({
    color = "#F8FAFC"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill={color}
            d="M12 28q-.824 0-1.413-.587A1.93 1.93 0 0 1 10 26V14q0-.824.587-1.413A1.93 1.93 0 0 1 12 12h16q.824 0 1.413.587Q30 13.175 30 14v12q0 .824-.587 1.413A1.93 1.93 0 0 1 28 28zm8-7-8-5v10h16V16zm0-2 8-5H12zm-7.963-3v-2 12z"
        ></path>
    </svg>
);

export default MessagesLetterIconSVG;
